import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NewCustomerService } from '../../../services/new-customer.service';
import { NewCustomerBanner } from '../new-customer-banner/new-customer-banner';

// Zone di codifica: con una sola zona per tipologia la scelta è già fatta e lo step si salta, tranne fuori zona
@Component({
  selector: 'ord-new-customer-zones',
  imports: [MatButtonModule, MatFormFieldModule, MatSelectModule, NewCustomerBanner],
  templateUrl: './new-customer-zones.html',
  styleUrl: './new-customer-zones.scss',
})
export class NewCustomerZones {
  readonly flow = inject(NewCustomerService);

  selectOil(value: string | null): void {
    this.flow.setZones(this.flow.oilZones().find(zone => zone.value === value) ?? null, this.flow.zoneNonOil());
  }

  selectNonOil(value: string | null): void {
    this.flow.setZones(this.flow.zoneOil(), this.flow.nonOilZones().find(zone => zone.value === value) ?? null);
  }

  // Fuori zona la richiesta parte con le autorizzazioni della proposta: il pulsante prosegue
  continue(): void {
    if (this.flow.hasZone()) {
      this.flow.go('contact');
    }
  }
}
